import { Oficina } from '../models/Oficina';
import { makeCrudObject } from './api';

export default makeCrudObject<Oficina>('oficina');
